import { getColorByRank } from '../../content/getColorByRank'
import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import { REPORT_PARAM_KEYS, REPORT_PARAM_NAMES } from '../../types/REPORT_PARAM_NAMES'
import './Page6-metric-analytic.css'

const Page6 = () => {
  const { metricItems } = useSelectReportData()

  return (
    <div style={{ padding: '30px 23px 40px 23px' }}>
      <p className={'title-bold'}>Overview</p>
      <p className={'description-sub'}>In this section, we'll take a quick look at your key metrics.</p>
      <p className={'description-sub'}>You're off to a good start!</p>
      <p
        className={'subtitle'}
        style={{ marginBottom: 5 }}
      >
        Glucose data analysis
      </p>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <p className={'description-sub range-level-text'}>Very poor</p>
        <p className={'description-sub range-level-text'}>Poor</p>
        <p className={'description-sub range-level-text'}>Ok</p>
        <p className={'description-sub range-level-text'}>Good</p>
        <p className={'description-sub range-level-text'}>Very good</p>
      </div>
      {metricItems.map((m, i) => {
        return (
          <MetricProgressLine
            {...m}
            key={i}
          />
        )
      })}
    </div>
  )
}

export type MetricProgressLineProps = {
  param_key: REPORT_PARAM_KEYS
  param_name: REPORT_PARAM_NAMES
  title: string
  rank: number //1-5
  value: number
}

const MetricProgressLine = (props: MetricProgressLineProps) => {
  const rank = props.rank || 0
  const backgroundColor = getColorByRank(props.rank)
  const width = (rank / 5) * 100

  return (
    <div className={'progress-line'}>
      <div
        className={'progress-line-inner'}
        style={{ width: `${width}%`, backgroundColor, zIndex: 0 }}
      ></div>
      <p
        className={'progress-text'}
        style={{ zIndex: 1 }}
      >
        {props.title}
      </p>
    </div>
  )
}

export default Page6
